/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Field } from "formik";
import { iLocation } from "ps-shared";
import { PlaceResult } from "src/helpers/mapboxParser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import Autocomplete, { PlaceSelectCbResult, PlaceSelectedCb } from "./Autocomplete";

export interface ValidationFuncResult {
  err: string;
  valid: boolean;
}
export interface FormikMultiAddressProps {
  name: string;
  values: iLocation[];
  max: number;
  placeHolder: string;
  validationFunc?: (val: PlaceResult) => ValidationFuncResult;
}
export interface FormikMultiAddressState {
  selectedOption: any;
  placesSessionToken: string;
  locations: iLocation[];
  autocompleteInput: string;
  err: string;
}

export default class FormikMultiAddress extends React.Component<FormikMultiAddressProps, FormikMultiAddressState> {
  constructor(props: FormikMultiAddressProps) {
    super(props);
    console.log(props);
    this.state = {
      selectedOption: null,
      placesSessionToken: `${Date.now()}`,
      locations: this.props.values ? this.props.values : [],
      autocompleteInput: "",
      err: null,
    };
    this.handleAutoComplete = this.handleAutoComplete.bind(this);
    this.removeLocation = this.removeLocation.bind(this);
  }

  public handleAutoComplete(p: PlaceSelectedCb, form: any): Promise<PlaceSelectCbResult> {
    return new Promise((resolve) => {
      if (p.clear) {
        // ignore the clear
        resolve({ accepted: true });
      }
      if (
        this.state.locations.some((location) => {
          return location.lat === p.lat || location.lon === p.lon;
        })
      ) {
        // ignore
        return;
      }
      if (this.props.validationFunc) {
        // if it doesnt pass the validation func then show the error and return
        const result = this.props.validationFunc(p.result);
        if (!result.valid) {
          this.setState({
            err: result.err,
          });
          resolve({ accepted: false });
          return;
        }
      }
      const loc = {} as iLocation;
      loc.address = p.result.address;
      loc.city = p.result.city;
      loc.region = p.result.region;
      loc.country = p.result.country;
      loc.postalCode = p.result.postalCode;
      loc.lat = p.lat;
      loc.lon = p.lon;
      const stateLocations = this.state.locations;
      stateLocations.push(loc);
      this.setState({
        locations: stateLocations,
        err: null,
      });
      form.setFieldValue(this.props.name, this.state.locations);
      resolve({ accepted: true });
    });
  }

  public getDisplayAddress(location: iLocation): string {
    let address = null;
    if (location.address) {
      address = `${location.address} ${location.city}, ${location.region} ${location.postalCode}, ${location.country}`;
    }
    if (!address) {
      // is there city, region, country?
      if (location.city && location.region && location.country) {
        address = `${location.city}, ${location.region}, ${location.country}`;
      }
    }
    return address;
  }

  public removeLocation(location: iLocation, form: any) {
    const newLocs = this.state.locations.filter((loc) => {
      return loc !== location;
    });
    this.setState({
      locations: newLocs,
    });
    form.setFieldValue(this.props.name, newLocs);
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <Field name={this.props.name}>
          {({ form }: { field: any; form: any }) => (
            <>
              {this.state.locations.map((location) => {
                return (
                  <div key={`${location.lat}_${location.lon}`}>
                    {this.getDisplayAddress(location)}&nbsp;{" "}
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="cursor-pointer"
                      onClick={() => this.removeLocation(location, form)}
                    />
                  </div>
                );
              })}
              {this.state.locations.length < this.props.max && (
                <Autocomplete cb={(p) => this.handleAutoComplete(p, form)} />
              )}
              {this.state.err && <div className="form-feedback">{this.state.err}</div>}
              {this.state.locations.length >= this.props.max && this.props.max > 1 && (
                <>
                  <i>You've reached the maximum number of locations allowed</i>
                </>
              )}
            </>
          )}
        </Field>
      </>
    );
  }
}
